import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum, type User } from "@datadog/browser-rum";

/**
 * Attach Hopper user identity to RUM (all tenants).
 *
 * Do **not** write to browser Logs here — Logs retention/access differs by
 * tenant. Callers that need `@usr.id` on Logs (Nubank NVH-661/1070) must
 * also call {@link setDatadogLogsUser} explicitly.
 */
export const setDatadogUser = (user: User) => {
  if (datadogRum) {
    datadogRum.setUser(user);
  }
};

/** Attach Hopper user identity to browser Logs (opt-in per tenant). */
export const setDatadogLogsUser = (user: User) => {
  if (datadogLogs) {
    datadogLogs.setUser(user);
  }
};

/** Hopper UserId from Datadog RUM user context, if already set. */
export const getDatadogUserId = (): string | null => {
  try {
    const id = datadogRum?.getUser?.()?.id;
    return typeof id === "string" && id.length > 0 ? id : null;
  } catch {
    return null;
  }
};
